import { RouteRecordRaw } from "vue-router";
import authGuard from "@/router/authGuard";
import { Permissions } from "@/constants/access";
import { PartnerRouteNames } from "@/constants/routes";

const partnerRoutes: Array<RouteRecordRaw> = [
    {
        path: "/partner",
        name: PartnerRouteNames.PARTNER,
        component: () => import("@/views/partner/PartnerLayout.vue"),
        beforeEnter: authGuard,
        meta: {
            requiredPermissions: [Permissions.BASE],
        },
        // all the child routes will be rendered inside PartnerLayout's <router-view>
        // and will be available under the /partner namespace
        children: [
            // Dashboard not required for MVP
            // {
            //     path: "overview",
            //     name: PartnerRouteNames.OVERVIEW,
            //     component: () =>
            //         import("@/views/partner/overview/Overview.vue"),
            //     beforeEnter: authGuard,
            //     meta: {
            //         requiredPermissions: [Permissions.BASE],
            //     },
            // },
            {
                path: "transactions",
                name: PartnerRouteNames.TRANSACTIONS,
                component: () =>
                    import("@/views/partner/transactions/Transactions.vue"),
                beforeEnter: authGuard,
                meta: {
                    requiredPermissions: [Permissions.BASE],
                },
                children: [
                    {
                        path: "order-payments",
                        name: PartnerRouteNames.ORDER_PAYMENTS,
                        beforeEnter: authGuard,
                        component: () =>
                            import("@/views/partner/transactions/categories/OrderPayments.vue"),
                        meta: {
                            requiredPermissions: [Permissions.BASE],
                        },
                    },
                ],
            },
            {
                path: "support",
                name: PartnerRouteNames.SUPPORT,
                component: () => import("@/views/partner/support/Support.vue"),
                beforeEnter: authGuard,
                meta: {
                    requiredPermissions: [Permissions.BASE],
                },
            },
            {
                path: "settings",
                name: PartnerRouteNames.SETTINGS,
                component: () =>
                    import("@/views/partner/settings/Settings.vue"),
                beforeEnter: authGuard,
                meta: {
                    requiredPermissions: [Permissions.BASE],
                },
                children: [
                    {
                        path: "account-information",
                        name: PartnerRouteNames.ACCOUNT_INFORMATION,
                        beforeEnter: authGuard,
                        component: () =>
                            import("@/views/partner/settings/AccountInformation.vue"),
                        meta: {
                            requiredPermissions: [Permissions.BASE],
                        },
                    },
                ],
            },
        ],
    },
];

export default partnerRoutes.map((route) => {
    return { ...route };
});
